import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@novo-electronique/react-tooltip';
import classNames from 'classnames';

import { FormProvider } from './FormProvider';

export type TooltipSource = string | (() => void);

interface IProps {
  source: TooltipSource;
}

function FormFieldTooltip({ source }: IProps) {
  const { t } = useTranslation();
  const { labelsNamespace } = useContext(FormProvider);
  const targetRef = useRef();

  if (!source) {
    return null;
  }

  const isAction = source instanceof Function;
  const className = classNames('novoFormFieldTooltip', 'material-icons', {
    'novoFormFieldTooltip--action': isAction,
  });
  return (
    <React.Fragment>
      {!isAction && (
        <Tooltip targetRef={targetRef} offset={[0, 4]}>
          {source}
        </Tooltip>
      )}
      <span
        ref={targetRef}
        className={className}
        onClick={isAction ? () => (source as Function)() : undefined}
        title={isAction ? t(`${labelsNamespace}.tooltipAction`) : undefined}
      >
        info
      </span>
    </React.Fragment>
  );
}

export default FormFieldTooltip;
